import { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import InfoComplete from './InfoComplete';
import GenereCsv from './GenereCsv';
import ColumnChooser from './ColumnChooser';
import { cleanJson } from './utils/Columns';
import { FaTimes } from 'react-icons/fa';

const Export = ({ gotoAuth, annee }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');
    const [show, setShow] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés

    const [searchText, setSearchText] = useState('');
    const [adherents, setAdherents] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);

    const getAdherent = () => {
        if (code && code !== '')
            fetch(`${url}GetExport/${annee}/${code}`)
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.data)
                        gotoAuth();
                    else {
                        // Traiter la réponse si nécessaire
                        let adh = cleanJson(data.data);
                        setAdherents(adh);
                        setDataFiltered(adh);


                    }
                })
                .catch(error => console.error('Erreur:', error));
    };

    useEffect(() => {
        getAdherent();
    }, [annee]);


    useEffect(() => {
        setDataFiltered(adherents);
    }, [adherents]);


    const filtre = (value, data) => {
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, adherents);
    };

    const handleClose = () => setShow(false);

    const handleShow = (row) => {
        setAdherentSel(row);
        setShow(true);
    }

    const columnsSel = ['SIRET', 'NOM_DE_L_ENTREPRISE', 'NOM_ADHERENT', 'PRENOM_ADHERENT', 'TELEPHONE', 'RESEAU', 'NUMERO_DE_FEUILLE_DE_COTISATION', 'E_Mail_1'];
    // const [columns, setColumns] = useState([]);

    const [columns, setColumns] = useState([]);

    const handleRowClick = (row) => {
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        handleShow(row);
    };

    const uniqueNetworks = [...new Set(adherents.map(row => row.reseau))].sort();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const handleNetworkFilter = (network) => {
        setSelectedFeuille('');
        setSelectedNetwork(network);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (network === '') {
            setDataFiltered(adherents);
        } else {
            const filtered = adherents.filter(item => item.reseau === network);
            console.log(filtered)
            setDataFiltered(filtered);
        }
    };

    const uniqueFeuilles = [...new Set(adherents.map(row => row.reference))].sort();
    const [selectedFeuille, setSelectedFeuille] = useState('');
    const handleFeuilleFilter = (feuille) => {
        setSelectedNetwork('');
        setSelectedFeuille(feuille);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (feuille === '') {
            setDataFiltered(adherents);
        } else {
            const filtered = adherents.filter(item => item.reference === feuille);
            console.log(filtered);
            setDataFiltered(filtered);
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                <h1 style={{ marginLeft: '10px' }}>Export</h1>
                <div style={{ flexGrow: 1 }} />
                <ColumnChooser columnsName={columnsSel} data={dataFiltered} setColumns={setColumns} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedNetwork}</h3>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleNetworkFilter(e.target.value)} value={selectedNetwork}>
                    <option key="reseauVide" value="">Tous les réseaux</option>
                    {uniqueNetworks.map((network, index) => <option key={index + '-' + network} value={network}>{network}</option>)}
                </Form.Select>

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* <h1 style={{ marginLeft: '10px' }}>Adhésion</h1> */}
                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedFeuille}</h3>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleFeuilleFilter(e.target.value)} value={selectedFeuille}>
                    <option key="feuilleVide" value="">Toutes les feuilles</option>
                    {uniqueFeuilles.map((feuille, index) => <option key={index + '-' + feuille} value={feuille}>{feuille}</option>)}
                </Form.Select>

            </div>
            <DataTable
                columns={columns}
                data={dataFiltered}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                subHeader
                subHeaderComponent={(
                    // <div style={{ display: 'flex', alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                        <input
                            type="text"
                            value={searchText}
                            onChange={handleChangesearchText}
                            // onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Rechercher..."
                        />
                        {searchText && <FaTimes className='h-5' onClick={() => filtre('', adherents)} />}
                        <div style={{ flexGrow: 1 }} />
                        <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                    </div>
                )}
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
                onRowClicked={handleRowClick}
            />

            <Modal size="xl" show={show} onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <InfoComplete adherentLight={adherentSel} />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Export;
